import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type TitleProps = ComponentProps<'h2'>;

/**
 * A component that renders a title. Used in the FaqSection component.
 * @param children - The children of the title.
 * @param className - The class name of the title.
 * @param props - The props of the title.
 * @returns The title component.
 */
function Title({ children, className, ...props }: TitleProps) {
  return (
    <h2 className={twMerge('heading-5 mb-3', className)} {...props}>
      {children}
    </h2>
  );
}

export { Title };
